import classNames from "classnames";
import React, { Component } from "react";
import "../../../../styles/main.scss";

interface KuikaTextMediumProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
}

class KuikaTextMedium extends Component<KuikaTextMediumProps> {
  render() {
    const { children, className, ...props } = this.props;

    return (
      <span className={classNames("kuika-typography-text--medium", className)} {...props}>
        {children}
      </span>
    );
  }
}

export default KuikaTextMedium;
